import translate from '../../core/services/translate';

export const ACTIVE_USER_STATUS = 'Active';
export const INACTIVE_USER_STATUS = 'Inactive';

export const USER_STATUSES = [
  { id: ACTIVE_USER_STATUS, name: translate('common.active') },
  { id: INACTIVE_USER_STATUS, name: translate('common.inactive') },
];
